import React, { useEffect } from 'react';
import { useNavigate, Outlet } from 'react-router-dom';

import { Header, HeaderButton, HeaderLink } from '../components/header';
import { logout } from '../utils/firebase-config';

export const AdminSpace = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // const userAccessToken = localStorage.getItem('accessToken');
        // const uid = localStorage.getItem('uid');
        // const email = localStorage.getItem('email');
        // if (!userAccessToken && !uid && !email) {
        //     navigate('/login');
        // }
    }, []);

    const userLogout = async () => {
        await logout();
        const userAccessToken = localStorage.getItem('accessToken');
        const uid = localStorage.getItem('uid');
        const email = localStorage.getItem('email');
        if (!userAccessToken && !uid && !email) {
            navigate('/login');
        }
    };


    return (
        <>
            <Header actions={(
                <>
                    <HeaderLink to={'/'}>Home</HeaderLink>
                    <HeaderLink to={'/admin-space/create-post'}>Create</HeaderLink>
                    <HeaderLink to={'/admin-space/list-post'}>List</HeaderLink>
                    <HeaderButton isLogout={true} onClick={userLogout}>Logout</HeaderButton>
                </>
            )}/>
            <Outlet />
        </>
    );
};
